import { getLocale } from './get-locale.function';

export const getLocaleCountryCode = () => {
  const locale = getLocale();
  const [, countryCode] = locale.split('-');
  return countryCode === '419' ? 'CO' : countryCode;
};
